module.exports = __webpack_public_path__ + "img/shrine-2-1024.b00689f3.jpg";